const activeSlideIndex = (slides) => (entries) =>
  entries
    .filter(({ isIntersecting }) => isIntersecting)
    .map(({ target }) => slides.indexOf(target))
    .filter((index) => index >= 0)
    .at(-1);

export default activeSlideIndex;
